__turbopack_context__.v({
  "copyright": "GeneralSection-module-scss-module__jYal3a__copyright",
  "generalLinks": "GeneralSection-module-scss-module__jYal3a__generalLinks",
  "generalSection": "GeneralSection-module-scss-module__jYal3a__generalSection",
  "utility": "GeneralSection-module-scss-module__jYal3a__utility",
});
